import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ba2463"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedBack-container" }

import Investigate from "@/views/operate/components/feedBackCom/Investigate.vue";
import SiteMail from "@/views/operate/components/feedBackCom/SiteMail.vue";
import ContactService from "@/views/operate/components/feedBackCom/ContactService.vue";
import NewCertificate from "@/views/operate/components/feedBackCom/NewCertificate.vue";
import EmailConnect from "@/views/operate/components/feedBackCom/EmailConnect.vue";
import Ability from "@/views/operate/components/feedBackCom/Ability.vue";
import LearnCode from "@/views/operate/components/feedBackCom/LearnCode.vue";
import GrowthIcon from "@/views/operate/components/feedBackCom/GrowthIcon.vue";
import BenefitCourse from "@/views/operate/components/feedBackCom/BenefitCourse.vue";
import store from "@/store";
import {useRoute} from 'vue-router'
import { computed,ref } from 'vue'
import { 
  getVisitorSurvey
} from "@/api/request/user";
import { ElMessage, ElMessageBox } from "element-plus";
import VisitorSurvey from "@/views/operate/course/VisitorSurvey.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Feedback',
  setup(__props) {
 
const node_env = process.env.NODE_ENV;
const route = useRoute()
const isBig6Router = computed(() => {
  return store.state.user.userInfo.useType === '6';
  // return route.path.indexOf('/bigSeaAgent') !== -1
})


const visitorSurveyVisible = ref(false);
 

// 显示游客调查问卷
const showVisitorSurvey = async (s:string) => { 
     visitorSurveyVisible.value = true; 
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).getters.isLogin)
      ? (_openBlock(), _createBlock(NewCertificate, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(store).state.user.benefitCourseFlagIconDialog && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(BenefitCourse, {
            key: 0,
            class: "feedBack-item"
          }))
        : _createCommentVNode("", true),
      (_unref(store).state.user.isGrowthIconFlag && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(GrowthIcon, {
            key: 1,
            class: "feedBack-item"
          }))
        : _createCommentVNode("", true),
      (_unref(store).state.user.learnCodeFixedDialog && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(LearnCode, {
            key: 2,
            class: "feedBack-item"
          }))
        : _createCommentVNode("", true),
      (_unref(store).getters.isLogin && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(SiteMail, {
            key: 3,
            class: "feedBack-item",
            showVisitorSurvey: showVisitorSurvey
          }))
        : _createCommentVNode("", true),
      (!_unref(isBig6Router))
        ? (_openBlock(), _createBlock(ContactService, {
            key: 4,
            class: "feedBack-item"
          }))
        : _createCommentVNode("", true),
      (_unref(store).getters.isLogin && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(Investigate, {
            key: 5,
            class: "feedBack-item",
            showVisitorSurvey: showVisitorSurvey
          }))
        : _createCommentVNode("", true),
      (_unref(store).getters.isLogin && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(EmailConnect, {
            key: 6,
            class: "feedBack-item",
            showVisitorSurvey: showVisitorSurvey
          }))
        : _createCommentVNode("", true),
      (_unref(store).getters.isLogin && _unref(node_env) === 'development' && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createBlock(Ability, {
            key: 7,
            class: "feedBack-item",
            showVisitorSurvey: showVisitorSurvey
          }))
        : _createCommentVNode("", true),
      (visitorSurveyVisible.value)
        ? (_openBlock(), _createBlock(VisitorSurvey, { key: 8 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})